module.exports = __webpack_public_path__ + "img/MUE.93a9ffa4.svg";